import styled from 'styled-components'

import { mobileSSideNavWidth } from '../../styles/sizes'

const StyledNavApp = styled.nav`
	width: ${mobileSSideNavWidth};
`

export default StyledNavApp
